import { createI18n } from 'vue-i18n';
import en_AU from './locales/en-AU.json';

// Messages are broken down by the view name, keys should be camelCase, top Level keys will be PascalCase
// e.g. Login.vue -> Login.text

// Register global app components
const locales = import.meta.glob('./locales/*.json', { eager: true });
const messages: unknown = {};

for(const path in locales) {
  const localeName = path.replace(/^.*\/(.*)\.\w+$/, '$1');

  messages[localeName] = (locales[path] as any).default;
}

const numberLocales = import.meta.glob('./numberLocales/*.json', { eager: true });
const numberFormats: unknown = {};

for(const path in numberLocales) {
  const localeName = path.replace(/^.*\/(.*)\.\w+$/, '$1');

  numberFormats[localeName] = (numberLocales[path] as any).default;
}

type MessageSchema = typeof en_AU;

const i18nInstance = createI18n<[MessageSchema], 'en-AU' | 'id-ID'>({
  legacy: false,
  globalInjection: true,
  locale: 'en-AU',
  fallbackLocale: 'en-AU',
  messages: messages as any,
  numberFormats: numberFormats as any,
});

export default i18nInstance;

export const i18n = i18nInstance.global;

export const n = i18nInstance.global.n;

export const t = i18nInstance.global.t;

export const d = i18nInstance.global.d;

export * from '@/helpers/i18n';
